import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const FUNDS_TRANSFER = 'funds-transfer';

export const VALIDATION_FIELDS_FUNDS_TRANSFER = [VALIDATION_FIELDS.amount];
